import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import "./StatusBar.scss";

class StatusBar extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const percentage = this.props.percentage || null;
        const maxSteps = this.props.maxSteps || null;
        const step = this.props.step || null;
        const currentStatus = this.props.currentStatus || "";
        const sales = this.props.sales || false;
        const statusColor = this.props.statusColor;
        const statusBarStyle = {};
        let barStyle = {};
        if (this.props.style) {
            Object.assign(statusBarStyle, this.props.style);
        }

        let displayPercentage = 0;
        if (percentage > 0) {
            displayPercentage = percentage;
        }
        if (maxSteps > 0) {
            displayPercentage = ((step || 0) / maxSteps) * 100.0;
        }
        if (displayPercentage > 100) {
            displayPercentage = 100;
        }
        if (displayPercentage < 0) {
            displayPercentage = 0;
        }

        if (statusColor) {
            barStyle = {
                width: displayPercentage + "%",
                backgroundColor: statusColor,
            };
        } else {
            barStyle = {
                width: displayPercentage + "%",
            };
        }

        return (
            <React.Fragment>
                <ReactTooltip effect="solid" place="top" className="tool-tip" />
                {sales ? (
                    <div
                        className="status-bar"
                        style={statusBarStyle}
                        data-tip={currentStatus}
                    >
                        <div className="status-bar-progress">
                            <div className="status-bar-background" />
                            <div
                                className="status-bar-progress-bar"
                                style={barStyle}
                            />
                        </div>
                    </div>
                ) : (
                    <div
                        className="status-bar"
                        style={statusBarStyle}
                        title={currentStatus}
                        >
                        <div className="status-bar-progress">
                            <div className="status-bar-background" />
                            {displayPercentage >= 75 ? (
                                <div
                                    className="status-bar-progress-orange-bar"
                                    style={barStyle}
                                />
                            ) : (
                                <div
                                    className="status-bar-progress-bar"
                                    style={barStyle}
                                />
                            )}
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default StatusBar;
